import React from 'react';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router';
import AuthorizedComponent from '../../../../components/AuthorizedComponent';
import { ROLES, ABNORMALITIES } from '../../../../constants';

const AbnormalitySectionModal = ({ onHide, backdrop, runId, showModal, onCloseModal }) => (
    <Modal show={showModal} bsSize="lg" backdrop={backdrop} onHide={onHide}>
        <Modal.Header>
            <Modal.Title>Abnormality creation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row style={{ margin: 'auto 0' }}>
                <AuthorizedComponent requiredRoles={[ROLES.ABNORMALITY_DELAY_CREATOR]}>
                    <Col sm={4}>
                        <h4 style={{ margin: '0px 20px' }}>Time related</h4>
                        <Row style={{ margin: '0px 20px' }}>
                            <Link to={`/runs/${runId}/abnormality/DELAY`}>
                                <Button
                                    bsStyle="primary"
                                    style={{
                                        width: '100%',
                                        marginBottom: 5,
                                        marginTop: 15,
                                    }}
                                >
                                    Delay
                                </Button>
                            </Link>
                        </Row>
                    </Col>
                </AuthorizedComponent>
                <AuthorizedComponent
                    requiredRoles={[
                        ROLES.ABNORMALITY_BLOWOUT_CREATOR,
                        ROLES.ABNORMALITY_MISCOLLECTION_CREATOR,
                    ]}
                >
                    <Col sm={4}>
                        <h4 style={{ margin: '0px 20px' }}>Manifest related</h4>
                        <Row style={{ margin: '0px 20px' }}>
                            <Col sm={12}>
                                <AuthorizedComponent
                                    requiredRoles={[ROLES.ABNORMALITY_BLOWOUT_CREATOR]}
                                >
                                    <Row>
                                        <Link
                                            to={`/runs/${runId}/abnormality/${
                                                ABNORMALITIES.BLOWOUT
                                            }`}
                                        >
                                            <Button
                                                bsStyle="primary"
                                                style={{
                                                    width: '100%',
                                                    marginBottom: 5,
                                                    marginTop: 15,
                                                }}
                                            >
                                                Blow Out
                                            </Button>
                                        </Link>
                                    </Row>
                                </AuthorizedComponent>
                                <AuthorizedComponent
                                    requiredRoles={[ROLES.ABNORMALITY_MISCOLLECTION_CREATOR]}
                                >
                                    <Row>
                                        <Link
                                            to={`/runs/${runId}/abnormality/${
                                                ABNORMALITIES.MISCOLLECTION
                                            }`}
                                        >
                                            <Button
                                                bsStyle="primary"
                                                style={{
                                                    width: '100%',
                                                    marginBottom: 5,
                                                    marginTop: 15,
                                                }}
                                            >
                                                Miscollection
                                            </Button>
                                        </Link>
                                    </Row>
                                </AuthorizedComponent>
                            </Col>
                        </Row>
                    </Col>
                </AuthorizedComponent>
                <AuthorizedComponent requiredRoles={[ROLES.ABNORMALITY_GENERIC_CREATOR]}>
                    <Col sm={4}>
                        <h4 style={{ margin: '0px 20px' }}>Generic</h4>
                        <Row style={{ margin: '0px 20px' }}>
                            <Col sm={12}>
                                <Row>
                                    <Link
                                        to={`/runs/${runId}/abnormality/${ABNORMALITIES.GENERIC}`}
                                    >
                                        <Button
                                            bsStyle="primary"
                                            style={{
                                                width: '100%',
                                                marginBottom: 5,
                                                marginTop: 15,
                                            }}
                                        >
                                            Generic
                                        </Button>
                                    </Link>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </AuthorizedComponent>
            </Row>
            <div style={{ textAlign: 'right', marginTop: 20 }}>
                <Button style={{ marginRight: 20 }} bsStyle="default" onClick={onCloseModal}>
                    Close
                </Button>
            </div>
        </Modal.Body>
    </Modal>
);

export default AbnormalitySectionModal;
